<template>
	<v-card class="pa-5 full-width">
		<v-layout v-if="isRetailer">
			<div class="headline mb-5">Rank List</div>
		</v-layout>

		<div v-else-if="isRetailAdmin">
			<h5 class="headline mb-5">Find Your Rank</h5>

			<div>
				<v-layout row wrap>
					<v-flex xs12 md6 lg4>
						<v-text-field label="Enter Retailer ID" v-model="retailerId"></v-text-field>
					</v-flex>
				</v-layout>

				<select-state-city-mm :showFilter="true" @UPDATED_VALUES="updatedStateCityMM" />

				<v-layout>
					<v-flex class="no-flex-grow verCenteredChild">
						<v-btn color="blue" class="pa-0 my-4 mx-0 white--text" @click="fetchRankList(top)">Search</v-btn>
					</v-flex>
				</v-layout>
			</div>
		</div>

		<div v-if="retailersTopRankList && retailersTopRankList.length">
			<advance-list-view
				:allData="retailersTopRankList"
				:allProps="allProps"
				:nextOffset="!lastKey ? 'end' : ''"
				@LOAD_MORE_ROWS="fetchRankList(end)"
				:loadMoreLoading="fetchRankListLoading"
				uniqueKey="id"
				:isTableInteractive="false"
				:themeInputColor="themeInputColor"
				:noPagination="true"
				:hasLoadMore="true"
			/>
		</div>

		<div v-else-if="fetchRankListLoading" class="allCenteredChild">
			<v-progress-circular indeterminate :color="themeInputColor" :size="50" />
		</div>
	</v-card>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import SelectStateCityMM from "@/components/select-state-city-mm";
import AdvanceListView from "@/components/Advance-list-view";
import {
	GET_RETAILERS_RANKLIST,
	RESET_RETAILERS_RANKLIST
} from "@/store/action-types";
import { themeInputColor, REGION_TYPE } from "@/utils";
import { SEARCH, TOP, END } from "@/store/config";

export default {
	name: "RetailerRanklist",
	data() {
		return {
			retailerId: null,
			menu: false,
			selectedState: null,
			selectedMicroMarket: null,
			selectedCity: null,
			feedType: REGION_TYPE.STATE,
			filterKey: null,
			allProps: [
				{ text: "Pic", key: "pic" },
				{ text: "User ID", key: "id", copy_allowed: true },
				{ text: "Name", key: "name" },
				{
					text: "handle",
					key: "handle",
					copy_allowed: true,
					text_transform: false
				},
				{ text: "Install Count", key: "installCount" },
				{ text: "Amount Earned (in Rs.)", key: "totalAmount" }
			],
			themeInputColor,
			fetchRankListLoading: false,
			end: END,
			top: TOP
		};
	},
	mounted() {
		this.resetRetailerRankList();
		if (this.retailerData) {
			this.retailerId = this.retailerData.userId;
			this.filterKey = this.retailerData.state;
			this.fetchRankList(TOP);
		}
	},
	components: {
		"select-state-city-mm": SelectStateCityMM,
		"advance-list-view": AdvanceListView
	},
	computed: {
		...mapState({
			grabRetailerRank: state => state.retail.grabRetailerRank,
			retailersTopRankList: state => state.retail.retailersTopRankList,
			retailerData: state => state.retail.retailerData,
			lastKey: state => state.retail.lastKey
		}),
		...mapGetters({
			isRetailAdmin: "auth/isRetailAdmin",
			isRetailer: "auth/isRetailer"
		})
	},
	methods: {
		updatedStateCityMM(payload, feedType, filterKey) {
			const {
				selectedState,
				selectedCity,
				selectedMicroMarket
			} = payload;

			this.selectedState = selectedState;
			this.selectedCity = selectedCity;
			this.selectedMicroMarket = selectedMicroMarket;

			this.feedType = feedType;
			this.filterKey = filterKey;
		},

		fetchRankList(type) {
			if (!this.fetchRankListLoading) {
				this.fetchRankListLoading = true;
				const payload = {
					userId: this.retailerId,
					feedType: this.feedType,
					filterKey: this.filterKey,
					type
				};
				this.$store
					.dispatch(GET_RETAILERS_RANKLIST.dispatch, payload)
					.catch(() => {})
					.then(() => {
						this.fetchRankListLoading = false;
					});
			}
		},
		resetRetailerRankList() {
			this.$store.dispatch(RESET_RETAILERS_RANKLIST.dispatch);
		}
	},
	watch: {
		selectedState(newVal) {
			if (newVal) {
				this.resetRetailerRankList();
			}
		},
		retailerData(newVal) {
			if (newVal) {
				this.retailerId = newVal.userId;
				this.filterKey = newVal.state;
				this.fetchRankList(TOP);
			}
		}
	}
};
</script>
